import { type ReactElement } from 'react';

import { useSession } from '@/auth/use-session';
import { LoginScreen } from '@/screens/LoginScreen';
import { SystemPanel } from '@/screens/SystemPanel';

// Three states, one gate. While the initial getSession() is in flight we render
// a neutral loading screen rather than flashing the login form; `null` means
// signed out; a real Session hands off to the backoffice.
//
// NOTE: signing in is necessary but NOT sufficient — authorisation is enforced
// server-side by the platform-admin allowlist. A signed-in non-admin reaches
// SystemPanel and sees an "access denied" state from the API's 403, never data.
export const App = (): ReactElement => {
  const session = useSession();

  if (session === undefined) {
    return (
      <div className="grid min-h-screen place-items-center bg-surface-2">
        <p className="text-sm text-text-secondary">Cargando…</p>
      </div>
    );
  }

  if (session === null) {
    return <LoginScreen />;
  }

  return <SystemPanel session={session} />;
};
